import { Box, FormControlLabel, Grid, Switch, Typography } from '@mui/material'
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined'
import SelectableCard from '../../components/Card/SelectableCard'
import { AlertDto, AlertSendStatus, AlertSendType } from '../../interfaces/IAlert'

interface AlertTypeSelectionCardsProps {
  newAlert: AlertDto
  handleAlertTypeChange: (name: string, type: AlertSendType | string) => void
  onIsDraftChange: (isDraft: boolean) => void
}

function AlertTypeSelectionCards({ newAlert, handleAlertTypeChange, onIsDraftChange }: AlertTypeSelectionCardsProps) {
  const isDraft = newAlert.status === AlertSendStatus.Draft


  const handleAlertTypeLabelSelection = (type: AlertSendType) => {
    const labels: Record<string, string> = {
      Immediate: 'Umiddelbar',
      Scheduled: 'Planlagt',
    }
    return labels[type]
  }

  const handleAlertTypeIconSelection = (type: AlertSendType) => {
    const types: Record<string, React.ReactNode> = {
      Immediate: <NotificationsActiveOutlinedIcon />,
      Scheduled: <AccessTimeOutlinedIcon />,
    }
    return types[type]
  }

  return (
    <>
      {Object.values(AlertSendType).map((type, index) => (
        <Grid
          key={index}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <SelectableCard
            icon={handleAlertTypeIconSelection(type)}
            label={handleAlertTypeLabelSelection(type)}
            selected={newAlert.type === type}
            onClick={() => {
              handleAlertTypeChange('type', type)
            }}
          />
        </Grid>
      ))}

      <Grid size={{ xs: 12 }}>
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            border: 1,
            borderRadius: '8px',
            borderColor: isDraft ? 'warning.main' : 'divider',
            bgcolor: isDraft ? 'warning.50' : 'transparent',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <DraftsOutlinedIcon color={isDraft ? 'warning' : 'disabled'} fontSize="small" />
          <FormControlLabel
            control={
              <Switch
                checked={isDraft}
                onChange={(e) => onIsDraftChange(e.target.checked)}
                color="warning"
                size="small"
              />
            }
            label={
              <Typography variant="body2" color={isDraft ? 'warning.dark' : 'text.secondary'}>
                {isDraft ? 'Lagres som utkast (sendes ikke automatisk)' : 'Lagre som utkast'}
              </Typography>
            }
          />
        </Box>
      </Grid>
    </>
  )
}

export default AlertTypeSelectionCards
